import uiWrapperEditionAwarenessDropdownWrapperQuery$variables from '@atlassian/jira-relay/src/__generated__/uiWrapperEditionAwarenessDropdownWrapperQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPointParams } from './types.tsx';

export const editionAwarenessDropdownEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "edition-awareness-dropdown" */ './src/ui/index'),
	),
	getPreloadProps: ({ cloudId, productKey, projectKey }: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {
			projectKey,
		},
		queries: {
			editionAwareness: {
				parameters: uiWrapperEditionAwarenessDropdownWrapperQuery$variables,
				variables: {
					cloudId,
					hamsProductKey: productKey,
					projectKey: projectKey ?? '',
					hasProjectKey: (projectKey ?? '').trim().length > 0,
				},
			},
		},
	}),
});
